<div class="table-wrapper bg-white" *blockUI="'invoice-list'">
  <div class="mb-2 d-flex justify-content-end">
    <button class="btn viewBtn spear-button-background text-white btn-sm" (click)="openPopup(addClientContact,'lg')">
      Add Client Contact
    </button>
  </div>
  <table class="table spear-table-header-background search-spear-background">
    <caption>
      NPI
    </caption>
    <thead>
      <tr>
        <th
          class="border-0 cursor-pointer"
          scope="col"
        >
          Full Name
        </th>
        <th
          class="border-0 cursor-pointer"
          scope="col"
        >
          Company Name
        </th>
        <th
          class="border-0 cursor-pointer"
          scope="col"
        >
          Title
        </th>
        <th
          class="border-0 cursor-pointer"
          scope="col"
        >
          Email
        </th>
        <th
          class="border-0 cursor-pointer"
          scope="col"
        >
          Work Phone
        </th>
        <th
          class="border-0 cursor-pointer"
          scope="col"
        >
          Mobile Phone
        </th>
      </tr>
    </thead>

    <tbody *ngIf="clientContacts?.length; else showNoInvoice">
      <ng-container *ngFor="let contact of clientContacts">
        <tr class="bg-white">
          <td>{{ contact?.full_name }}</td>
          <td>{{ contact?.client_name }}</td>
          <td>{{ contact?.title }}</td>
          <td>{{ contact?.email }}</td>
          <td>{{ contact?.work_phone }}</td>
          <td></td>
        </tr>
      </ng-container>
    </tbody>
    <ng-template #showNoInvoice>
      <tbody>
        <tr class="bg-white">
          <td colspan="6" class="text-center">Data not available</td>
        </tr>
      </tbody>
    </ng-template>
  </table>
</div>
<div class="invoice-pagination">
  <div
    class="px-0 py-0 spearPaginationWrapper paginationWrapper d-flex"
    *ngIf="clientContacts?.length"
  >
    <ngb-pagination
      [(collectionSize)]="invoiceTotal"
      [(page)]="invoicePage"
      [pageSize]="invoiceLimit"
      [maxSize]="10"
      [boundaryLinks]="true"
      (pageChange)="onPageChangeinvoices($event)"
    >
    </ngb-pagination>

    <div class="selected d-flex align-items-center">
      <select
        (change)="onSizeChangeinvoices($event.target.value)"
        class="custom-select table-select h-100"
        [(ngModel)]="invoiceLimit"
      >
        <option [value]="30">30</option>
        <option [value]="50">50</option>
        <option [value]="75">75</option>
        <option [value]="100">100</option>
      </select>

      <p class="mb-0 ml-2 text-nowrap">
        Showing {{ invoicePage * invoiceLimit - invoiceLimit + 1 }} -
        {{
          invoicePage * invoiceLimit > invoiceTotal
            ? invoiceTotal
            : invoicePage * invoiceLimit
        }}
        of {{ invoiceTotal }}
      </p>
    </div>
  </div>
</div>

<ng-template #addClientContact let-modal>
  <div class="modal-header">
    <h6>Add Client Contact</h6>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modalService.dismissAll()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-form text-sm">
    <form [formGroup]="addClientContactForm">
      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500 required" for="client"
              >Client</span
            >
          <select id="client" class="form-control" multiSelect2 [fetchFn]="searchClient$"
              [formCtrl]="addClientContactForm.get('client')" (change)="onChangeClient($event.target.value)"></select>
          </div>
        </div>

        <div class="col-6">
          <div>
            <span class="text-dark fw-500 required" for="client"
              >Add Program Location</span
            >
            <select type="text" class="form-control" id="program_name" formControlName="program_name">
              <option value="">Select Program Name</option>
              <option [value]="program.id" *ngFor="let program of clientPrograms">{{ program.name }}</option>
            </select>
          </div>
        </div>

      </div>

      <div class="row mb-2">
        <div class="col-4">
          <div>
            <span class="text-dark fw-500 required" for="first_name"
              >First Name</span
            >
            <input
              type="text"
              name="first_name"
              id="first_name"
              class="form-control"
              formControlName="first_name"
            />
          </div>
        </div>

        <div class="col-4">
          <div>
            <span class="text-dark fw-500 required" for="last_name"
              >Last Name</span
            >
            <input
              type="text"
              name="last_name"
              id="last_name"
              class="form-control"
              formControlName="last_name"
            />
          </div>
        </div>

        <div class="col-4">
          <div>
            <span class="text-dark fw-500 required" for="title"
              >Title</span
            >
            <input
              type="text"
              name="title"
              id="title"
              class="form-control"
              formControlName="title"
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="email"
              >Email</span
            >
            <input
              type="text"
              name="email"
              id="email"
              class="form-control"
              formControlName="email"
            />
          </div>
        </div>
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="work_phone"
              >Work Phone</span
            >
            <input
              type="text"
              name="work_phone"
              id="work_phone"
              class="form-control"
              formControlName="work_phone"
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="mobile_phone"
              >Mobile Phone</span
            >
            <input
              type="text"
              name="mobile_phone"
              id="mobile_phone"
              class="form-control"
              formControlName="mobile_phone"
            />
          </div>
        </div>
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="date_of_birth"
              >Date of Birth</span
            >
            <input
              type="text"
              name="date_of_birth"
              id="date_of_birth"
              class="form-control"
              [formCtrl]="addClientContactForm.get('dob')"
              jDate
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-12">
          <div>
            <span class="text-dark fw-500" for="general_notes"
              >General Notes</span
            >
            <textarea
              name="general_notes"
              id="general_notes"
              class="w-100 border"
              formControlName="general_notes"
            >
          </textarea>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="username"
              >Username</span
            >
            <input
              type="text"
              name="username"
              id="username"
              class="form-control"
              formControlName="username"
            />
          </div>
        </div>
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="password"
              >Password</span
            >
            <input
              type="text"
              name="password"
              id="password"
              class="form-control"
              formControlName="password"
            />
          </div>
        </div>
      </div>

      <div class="mt-4 d-flex justify-content-end">
        <div>
          <button
            type="button"
            class="btn btn-secondary btn-sm text-white mr-1"
            (click)="modalService.dismissAll()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn limos-button-background btn-sm text-white mr-1"
            (click)="saveClientContact()"
            [disabled]="addClientContactForm.invalid"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
